// ===============================
// drawer.js — single-init accordion
// ===============================

if (window.__DRAWER_INIT__) {
	console.warn('[drawer] already initialized — skipping');
} else {
	window.__DRAWER_INIT__ = true;

	window.addEventListener('DOMContentLoaded', () => {
		console.log('✅ DOM loaded, initializing drawer.js');

		// --- TLDR page lottie (the "Made with love" heart) ---
		// home.js only initializes lottie containers on the front page, so the
		// TLDR page does its own init here. Same per-container guard.
		if (document.querySelector('.tldr-page')) {
			document.querySelectorAll('.lottie[data-json]').forEach((elem) => {
				if (elem.dataset.lottieInit) return;
				if (typeof lottie === 'undefined') return;
				elem.dataset.lottieInit = '1';
				lottie.loadAnimation({
					container: elem,
					renderer: 'svg',
					loop: true,
					autoplay: true,
					path: elem.dataset.json,
				});
			});
		}

		const accordionHeaders = document.querySelectorAll('.player-heading');
		console.log('Found accordion headers:', accordionHeaders.length);

		if (!accordionHeaders.length) {
			console.warn('⚠️ No accordion headers found, exiting.');
			return;
		}

		// --- Auto-expand first accordion ---
		function handleAutoExpand() {
			console.log('Initializing auto-expand');
			accordionHeaders.forEach((header, index) => {
				const panelId = header.getAttribute('aria-controls');
				const panel = document.getElementById(panelId);

				if (!panel) {
					console.warn(
						`⚠️ No panel found for header index ${index} (id: ${panelId})`
					);
					return;
				}

				if (index === 0) {
					console.log(
						`👉 Expanding first accordion item (id: ${panelId})`
					);
					header.setAttribute('aria-expanded', 'true');
					header.classList.add('active');
					panel.removeAttribute('hidden');
				} else {
					header.setAttribute('aria-expanded', 'false');
					header.classList.remove('active');
					panel.setAttribute('hidden', '');
				}
			});
		}

		// --- Handle click toggle ---
		function handleToggle(header, panel) {
			if (!panel) {
				console.error(
					'❌ Tried to toggle but no panel found for header:',
					header
				);
				return;
			}

			console.log(`🔄 Toggling accordion for panel ID: ${panel.id}`);
			const isExpanded = header.getAttribute('aria-expanded') === 'true';
			console.log('Current expanded state:', isExpanded);

			header.setAttribute('aria-expanded', String(!isExpanded));
			header.classList.toggle('active');

			if (isExpanded) {
				console.log('Collapsing panel:', panel.id);
				panel.setAttribute('hidden', '');
			} else {
				console.log('Expanding panel:', panel.id);
				panel.removeAttribute('hidden');
			}
		}

		// --- Attach listeners once ---
		accordionHeaders.forEach((header) => {
			const panelId = header.getAttribute('aria-controls');
			const panel = document.getElementById(panelId);

			if (panel) {
				console.log(`Attaching click handler for panel ID: ${panelId}`);
				header.addEventListener(
					'click',
					() => handleToggle(header, panel),
					{ once: false }
				);
			} else {
				console.warn(
					`⚠️ No panel found for header with aria-controls="${panelId}"`
				);
			}
		});

		// --- TLDR slider toggle (Expand All / Collapse All) ---
		const sliderToggle = document.querySelector('.tldr-slider-toggle');
		const expandLabel = document.getElementById('tldr-expand-label');
		const collapseLabel = document.getElementById('tldr-collapse-label');
		const pill = document.querySelector('.tldr-slider-pill');

		if (sliderToggle && expandLabel && collapseLabel && pill) {
			console.log('TLDR slider found, initializing');

			function expandAll() {
				accordionHeaders.forEach((header) => {
					const panel = document.getElementById(header.getAttribute('aria-controls'));
					if (!panel) return;
					header.setAttribute('aria-expanded', 'true');
					header.classList.add('active');
					panel.removeAttribute('hidden');
				});
				// Move pill to left (Expand All side)
				pill.style.left = '0';
				pill.style.width = '50%';
				pill.style.opacity = '1';
				expandLabel.classList.add('active');
				collapseLabel.classList.remove('active');
			}

			function collapseAll() {
				accordionHeaders.forEach((header) => {
					const panel = document.getElementById(header.getAttribute('aria-controls'));
					if (!panel) return;
					header.setAttribute('aria-expanded', 'false');
					header.classList.remove('active');
					panel.setAttribute('hidden', '');
				});
				// Move pill to right (Collapse All side)
				pill.style.left = '50%';
				pill.style.width = '50%';
				pill.style.opacity = '1';
				collapseLabel.classList.add('active');
				expandLabel.classList.remove('active');
			}

			expandLabel.addEventListener('click', expandAll);
			collapseLabel.addEventListener('click', collapseAll);

			// Set initial pill state to match default (collapsed)
			pill.style.left = '50%';
			pill.style.width = '50%';
			pill.style.opacity = '1';

			// --- Pin the slider where it lands (desktop only) ---
			// The slider starts in normal flow beside the page title. We
			// measure its landing position once, then swap to fixed at those
			// exact coordinates as soon as the user scrolls, so it "sticks
			// right there" with no jump.
			const sliderOuter = document.querySelector('.tldr-slider-outer');
			const desktopMq = window.matchMedia('(min-width: 1024px)');
			let stickTop = 0;
			let stickRight = 0;

			function unstickSlider() {
				sliderOuter.classList.remove('is-stuck');
				sliderOuter.style.top = '';
				sliderOuter.style.right = '';
			}

			function updateStuckState() {
				if (!desktopMq.matches) {
					unstickSlider();
					return;
				}
				if (window.scrollY > 0) {
					sliderOuter.style.top = `${stickTop}px`;
					sliderOuter.style.right = `${stickRight}px`;
					sliderOuter.classList.add('is-stuck');
				} else {
					unstickSlider();
				}
			}

			function measureSlider() {
				if (!desktopMq.matches) {
					unstickSlider();
					return;
				}
				// Measure from the in-flow position (unstick first so the
				// rect reflects the natural layout next to the title).
				sliderOuter.classList.remove('is-stuck');
				sliderOuter.style.top = '';
				sliderOuter.style.right = '';
				const rect = sliderOuter.getBoundingClientRect();
				// Landing viewport position = document offset (what you see
				// at scroll 0), regardless of current scroll.
				stickTop = rect.top + window.scrollY;
				stickRight = Math.max(
					0,
					Math.round(window.innerWidth - rect.right)
				);
				updateStuckState();
			}

			let resizeTimer;
			window.addEventListener('scroll', updateStuckState, {
				passive: true,
			});
			window.addEventListener('resize', () => {
				clearTimeout(resizeTimer);
				resizeTimer = setTimeout(measureSlider, 150);
			});
			// Re-measure after full load in case fonts shift the title row.
			window.addEventListener('load', measureSlider);
			measureSlider();
		} else {
			console.log('ℹ️ TLDR slider not present on this page.');
		}

		handleAutoExpand();
		console.log('✅ drawer.js initialized successfully');
	});
}
